/**
 * Client-side pricing settings readiness (mirrors backend assessPricingSettingsReadiness).
 */

import { CORE_MONETARY_KEYS } from "./pricingSettingsMeta.js";

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isApprovedMonetary(value) {
  return typeof value === "number" && Number.isFinite(value) && value > 0;
}

/**
 * @param {Record<string, unknown>} values
 * @returns {boolean}
 */
export function vehicleBandsHaveApprovedBase(values = {}) {
  const bands = Array.isArray(values["pricing.vehicles.bands"])
    ? values["pricing.vehicles.bands"]
    : [];
  return bands.some((band) => isApprovedMonetary(band?.baseAmount));
}

/**
 * @param {Record<string, unknown>} values - Form values keyed by setting key
 * @returns {{ ready: boolean, missingCore: string[], missingAll: string[] }}
 */
export function assessCorePricingReadiness(values = {}) {
  const truckLedOn = values["pricing.automation.truckLedLocal.enabled"] === true;

  const missingCore = [];
  if (truckLedOn) {
    if (!vehicleBandsHaveApprovedBase(values)) {
      missingCore.push("pricing.vehicles.bands");
    }
  } else {
    for (const key of CORE_MONETARY_KEYS) {
      if (!isApprovedMonetary(values[key])) {
        missingCore.push(key);
      }
    }
  }

  const missingAll = [];
  if (!values["pricing.policy.version"]) {
    missingAll.push("pricing.policy.version");
  }
  missingAll.push(...missingCore);

  return {
    ready: missingCore.length === 0 && Boolean(values["pricing.policy.version"]),
    missingCore,
    missingAll: [...new Set(missingAll)],
  };
}
